import React from "react";

export function RedoButtonIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#F2F2F2"
        d="M1.73 1.973h9.531V.322c0-.15.172-.233.288-.141l3.17 2.5a.177.177 0 01.05.219.177.177 0 01-.05.062l-3.17 2.5a.178.178 0 01-.288-.14V3.67H1.998v10.49h13.527a.18.18 0 01.178.18v1.339c0 .098-.08.178-.178.178H1.73A1.43 1.43 0 01.3 14.43V3.402c0-.788.641-1.429 1.429-1.429z"
      ></path>
    </svg>
  );
}